var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43289 0.0778992C3.17549 0.426905 1.60035 1.5552 0.701511 3.46698C0.0287299 4.89789 -0.189212 6.99317 0.175026 8.52868C0.528284 10.018 1.37509 11.6573 2.68105 13.3799C4.29293 15.506 6.78207 17.9709 9.58186 20.2136C10.0564 20.5937 11.7487 21.8721 11.9404 21.9953C12.0077 22.0385 12.3506 21.7935 13.5935 20.814C17.0235 18.1111 19.9682 15.1583 21.7688 12.6161C23.4655 10.2206 24.1664 8.21556 23.967 6.328C23.5832 2.69521 20.7777 0.00394157 17.3705 4.48371e-06C15.6202 -0.00203881 14.0234 0.694327 12.7489 2.01534C12.5554 2.21599 12.3126 2.49378 12.2094 2.63272C12.1061 2.77166 12.0111 2.88534 11.9982 2.88534C11.9853 2.88534 11.8903 2.77166 11.7871 2.63272C10.9742 1.53856 9.6459 0.60811 8.36002 0.231944C7.57843 0.00329385 6.33778 -0.061992 5.43289 0.0778992Z",
    fill: "#594AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart_icon.f545876414e9c81ae979864d8a9f0e65.svg";
export { ForwardRef as ReactComponent };